<!-- 选择外部联系人弹窗 -->
<template>
  <Dialog
    :visible="visible"
    position="bottom"
    @update:visible="e => (visible = e)"
  >
    <div class="select-external-user-dialog">
      <div class="select-external-user-dialog__title">请选择所服务的车主</div>
      <div class="select-external-user-dialog__content">
        <div
          v-for="item in list"
          :key="item.external_userid"
          :class="[
            'select-external-user-dialog__content__item',
            value === item.external_userid ? 'select-external-user-dialog__content__item--selected' : '',
            item.has_chat ? 'select-external-user-dialog__content__item--disabled' : ''
          ]"
          :disabled="item.has_chat"
          @click="() => handleSetOwner(item)"
        >
          <div class="select-external-user-dialog__content__item__avatar">
            <img src="../../imgs/default-avatar.png" alt=""/>
          </div>
          <div class="select-external-user-dialog__content__item__name">
            {{ item.name }}
          </div>
          <div v-if="!item.has_chat" class="select-external-user-dialog__content__item__check">
            <MaterialSymbolsCheck style="color: #fff;" />
          </div>
          <div v-else class="select-external-user-dialog__content__item__tag">已有服务群</div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog/Index.vue'
import MaterialSymbolsCheck from '@/components/icons/MaterialSymbolsCheck.vue'

export default {
  name: 'SelectExternalUserDialog',
  components: {
    Dialog,
    MaterialSymbolsCheck
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleSetOwner(item) {
      if (item.has_chat) return
      this.$emit('setOwner', item)
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheets/base/fn.less';

.select-external-user-dialog {
  padding: 30/@w2;
  display: flex;
  flex-direction: column;
  .gap-y(24/@w2);

  &__title {
    font-size: 34/@w2;
    line-height: 48/@w2;
    font-weight: 600;
    color: #1F2023;
    padding-bottom: 16/@w2;
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 50vh;
    overflow-y: auto;
    min-height: 100px;
    .gap-y(30/@w2);

    &__item {
      display: flex;
      align-items: center;
      .gap-x(20/@w2);
      background: #F7F8FB;
      padding: 36/@w2 30/@w2;
      border-radius: 16/@w2;
      border: 1px solid transparent;

      &__avatar {
        width: 90/@w2;
        height: 90/@w2;
        border-radius: 50%;
        overflow: hidden;
      }

      &__name {
        flex: 1;
        font-size: 30/@w2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &__check {
        width: 36/@w2;
        height: 36/@w2;
        min-width: 36/@w2;
        background: transparent;
        border: 1px solid #989EA9;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        font-size: 24/@w2;
      }

      &__tag {
        font-size: 24/@w2;
        color: #989EA9;
        line-height: 32/@w2;
        padding: 10/@w2 18/@w2;
        background: #DFDFE5;
        border-radius: 50/@w2;
      }

      &--selected {
        border-color: #217BFF;

        .select-external-user-dialog__content__item__check {
          border-color: #217BFF;
          background: #217BFF;
          color: #fff;
        }
      }

      &--disabled {
        opacity: 0.5;
        cursor: not-allowed;

        .select-external-user-dialog__content__item__name {
          color: #989EA9;
        }
      }
    }
  }
}
</style>
